import Dexie from "dexie";
import { IOrderData } from "../types";

export const db: any = new Dexie("myDatabase");

export const initializeDB = () => {
  db.version(1).stores({
    orders:
      "++id, symbol, strike, expiry, price, order, option, qty, key, time",
  });
};

export const addPosition = async (position: IOrderData) => {
  return db.orders.put(position);
};

export const deletePositions = (positions: IOrderData[]) => {
  db.orders
    .where("key")
    .anyOf(positions.map((v) => v.key))
    .delete();
};

export const updatePosition = (position: IOrderData) => {
  db.orders.where("id").equals(position.id).modify({ position });
};

export const getPositions = async (indexName: string) => {
  const positions: { [key: string]: IOrderData } = {};
  const orders = await db.orders.where("symbol").equals(indexName).toArray();
  const orderMap = getOrderMap(orders);
  Object.keys(orderMap).forEach((key) => {
    positions[key] = getPositionFromOrders(orderMap[key]);
  });
  return positions;
};

const getOrderMap = (orders: IOrderData[]) => {
  const map: { [key: string]: IOrderData[] } = {};
  orders.forEach((order) => {
    const expiryDate = new Date(order.expiry);
    expiryDate.setHours(20);
    if (expiryDate >= new Date()) {
      if (map[order.key]) {
        map[order.key].push(order);
      } else {
        map[order.key] = [order];
      }
    }
  });
  return map;
};

const getPositionFromOrders = (orders: IOrderData[]) => {
  let buyQty = 0,
    sellQty = 0,
    buyPrice = 0,
    sellPrice = 0;
  orders.forEach((order) => {
    if (order.qty > 0) {
      buyQty += order.qty;
      buyPrice += order.qty * order.price;
    } else {
      sellQty += order.qty;
      sellPrice += Math.abs(order.qty * order.price);
    }
  });
  const averageBuy = buyPrice / (buyQty || 1);
  const averageSell = Math.abs(sellPrice / (sellQty || 1));
  const remainingQty = buyQty + sellQty;
  let pNL = 0;
  if (remainingQty > 0) {
    pNL = sellPrice - (buyQty - remainingQty) * averageBuy;
  } else {
    pNL = Math.abs((sellQty - remainingQty) * averageSell) - buyPrice;
  }
  return {
    ...orders[0],
    qty: remainingQty,
    bookedPNL: pNL,
    price: remainingQty > 0 ? averageBuy : averageSell,
  };
};
